/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

// require("./bootstrap");
window.$ = window.jQuery = require("jquery");
window.Vue = require("vue");
import Vuex from "vuex";
require("./slick.min");
import AOS from "aos";
import "aos/dist/aos.css";

AOS.init({
    offset: 100, //všeobecny offset kvoli paddingom, nesedel trigger
    easing: "ease-in-out-cubic"
});

//import Channels from "./components/channels";
// import Grow from "./components/grow";
import Referral from "./components/referral";

//Imports for homepage
import Workplaces from "./components/workplaces";
import Iot_switcher from "./components/iot_switcher";
import build_switcher from "./components/build_switcher";
import Header from "./components/header";
import Animate from "./components/animate";
import AnimatePhone from "./components/animatePhone";
import Carousel from "./components/carousel";
import CookieConsent from "./components/cookieConsent";
import FeaturedIn from "./components/featuredIn";
// import Visual from "./components/visual";
import Footer from "./components/footer";
import Gallery from "./components/gallery";
import Meet from "./components/meet";
//Workplaces germany sites
import Teamwork from "./components/teamwork";
import Department from "./components/department";
import Vibes from "./components/vibes";
import DepartmentDevelopers from "./components/departmentDevelopers";
import Insights from "./components/insights";
//M&A
import PageFoldForm from "./components/pageFoldForm";
import DealingCarousel from "./components/dealingCarousel";
import smallBigSlider from "./components/smallBigSlider";
import ReferralForm from "./components/referralForm";
//Homepage & MA
import LearnMore from "./components/LearnMore";
import scrollDown from "./components/scrollDown";
// homepage and newsroom article detail
import Article from "./components/article";

//newsroom
import Newsroom from "./components/newsroom";
import GermanyFooter from "./components/germanyFooter";
// import mainForm from "./components/ma/mainForm";

window.CookieConsent = new CookieConsent(".cookie-consent");
window.LearnMore = new LearnMore(".visual__mouse");
window.animatePhone = new AnimatePhone(".maximum-value__graph--phone");
window.animate = new Animate(".animate");
window.referral = new Referral(".referral");
window.ReferralForm = new ReferralForm(".referral-form");
window.header = new Header(".header");
window.teamwork = new Teamwork(".teamwork");
window.footer = new Footer(".footer");
window.carousel = new Carousel(".build__gallery");
window.build_switcher = new build_switcher(".build__switcher");
window.departmentDevelopers = new DepartmentDevelopers(
    ".department-developers"
);
window.workplaces = new Workplaces(".workplaces");
window.vibes = new Vibes(".vibes");

window.insights = new Insights(".insights");
window.department = new Department(".department-intro");
// window.germanyFooter = new GermanyFooter(".germany-footer");
window.pageFoldForm = new PageFoldForm(".pagefold-form");
// window.visual = new Visual(".visual");
window.gallery = new Gallery(".gallery");
window.newsroom = new Newsroom(".newsroom");
window.article = new Article(".article__widget");
window.meet = new Meet(".meet");
window.Iot_switcher = new Iot_switcher(".build__iot-switcher");
window.DealingCarousel = new DealingCarousel(".dealing");
window.smallbig = new smallBigSlider(".small-and-big");
window.scrollDown = new scrollDown();
window.FeaturedIn = new FeaturedIn(".featuredIn");
// window.mainForm = new mainForm(".form_section__form");

//Vue components

import JobOffersComponent from "./components/JobOffersFilter/JobOffers.vue";
import { store } from "./store/store";

const app = new Vue({
    el: "#app",
    components: {
        "job-offers": JobOffersComponent
    },
    store
});

//window.germanLinks = new GermanLinks();
